import React, { useState, useEffect } from "react";
import { Steps } from 'antd';
import AboutCoach from "./about";
import Evidence from "./evidence";
import Clubs from "./clubs";
import PaymentMethod from "./paymentMethod";
import Credit from "./credit";
import Withdraw from "./withdraw";
import Deposit from "./deposit";

export default function CoachProfile() {
    const [current, setCurrent] = useState(0);
    const queryParams = new URLSearchParams(window.location.search);
    const userId = queryParams.get('id');


    const Render = (c) => {
        switch (c) {
            case 0: return <AboutCoach userId={userId} pager={pager} />
            case 1: return <Evidence userId={userId} pager={pager}/>
            case 2: return <Clubs userId={userId} pager={pager}/>
            case 3: return  <Credit userId={userId} pager={pager}/>
            case 4: return <PaymentMethod userId={userId} pager={pager}/>
            case 5: return <Withdraw userId={userId}  pager={pager}/>
            case 6: return <Deposit userId={userId}  pager={pager}/>
            // default: return  <Credit userId={userId}/>
        }
    }

    const pager=(e)=>{
        setCurrent(e)
    }

    return (
        <>
            <Steps
                style={{ fontFamily: "iranSans" }}
                current={current}
                onChange={(e) => setCurrent(e)}
                items={[
                    {
                        title: 'درباره مربی',
                    },
                    {
                        title: 'مدرک مربی',
                    },
                    {
                        title: 'باشگاه ها',
                    },
                    {
                        title: 'اعتبار کاربر',
                    },
                    {
                        title: 'روش های پرداخت',
                    },
                    {
                        title: 'برداشت از کیف پول',
                    },
                    {
                        title: 'شارژ کیف پول',
                    },
                ]}
            />

            <div style={{ width: '100%', marginTop: '45px' }}>
                {Render(current)}
            </div>
        </>
    )
}